// scroll-animations.js
//
// Sections werden beim Hereinscrollen eingeblendet. Entscheidend für LCP: Nur Sections,
// die beim Laden UNTERHALB des Sichtbereichs liegen, bekommen die Klasse `will-animate`
// (und damit opacity: 0). Alles im ersten Bildschirm rendert sofort und kann als LCP
// gewertet werden.

(function () {
  function init() {
    var sections = document.querySelectorAll('#MainContent .shopify-section');
    if (!sections.length) return;

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window) || reduceMotion) return;

    var sectionObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // nur einmal animieren
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.05,
      }
    );

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var animated = [];

    sections.forEach(function (section) {
      // Bereits sichtbar oder knapp darunter: nicht verstecken, sofort rendern lassen.
      if (section.getBoundingClientRect().top < viewportHeight * 1.15) return;
      section.classList.add('will-animate');
      animated.push(section);
      sectionObserver.observe(section);
    });

    // Sicherheitsnetz: falls etwas schiefgeht, alles sichtbar machen.
    window.addEventListener('load', function () {
      setTimeout(function () {
        animated.forEach(function (section) {
          if (!section.classList.contains('is-visible')) {
            section.classList.add('is-visible');
          }
        });
      }, 2500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();